"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryFilterDrawer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const default_1 = require("./plugins/default");
const SelectQueryBuilder2_1 = require("./query-builder/SelectQueryBuilder2");
const StyledDiv = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  min-height: min-content;
  flex: 1 1 auto;
  padding: 20px;
  background: #f4f4f4;
  .button {
    margin-top: 32px;
  }
  .spacer {
    flex: 1;
  }
`;
const QueryFilterDrawer = props => {
    const { action, children, query: queryProp, defaultHideAdvanced, onQueryChange } = props, drawerProps = __rest(props, ["action", "children", "query", "defaultHideAdvanced", "onQueryChange"]);
    const [query, setQuery] = (0, react_1.useState)(queryProp);
    const [hideAdvanced, setHideAdvanced] = (0, react_1.useState)(defaultHideAdvanced !== null && defaultHideAdvanced !== void 0 ? defaultHideAdvanced : true);
    // override default plugins
    const plugins = (0, react_1.useMemo)(() => {
        return props.plugins || default_1.defaultQueryBuilderPlugins;
    }, [props.plugins]);
    // update state when queryProp changes
    (0, react_1.useEffect)(() => {
        queryProp && setQuery(queryProp);
    }, [queryProp]);
    return (react_1.default.createElement(core_1.Drawer, Object.assign({ open: true, anchor: 'right' }, drawerProps),
        react_1.default.createElement(StyledDiv, { className: 'drawer-content', style: { width: 420 } },
            react_1.default.createElement(core_1.Grid, { container: true },
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Typography, { variant: 'h2' }, "Filters")),
                react_1.default.createElement("div", { className: 'spacer' }),
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Button, { size: 'small', color: 'primary', variant: 'outlined', onClick: () => setHideAdvanced(hideAdvanced => !hideAdvanced) },
                        hideAdvanced ? 'Show' : 'Hide',
                        " Advanced"))),
            react_1.default.createElement(SelectQueryBuilder2_1.SelectQueryBuilder2, { hideAdvanced: hideAdvanced, plugins: plugins, query: query, onChange: query => {
                    setQuery(query);
                } }),
            children,
            react_1.default.createElement(core_1.Button, { fullWidth: true, variant: 'contained', disabled: !query, color: 'primary', className: 'button apply-filter', onClick: () => {
                    query && (onQueryChange === null || onQueryChange === void 0 ? void 0 : onQueryChange(query));
                } }, "Apply Filter"),
            action)));
};
exports.QueryFilterDrawer = QueryFilterDrawer;
exports.default = exports.QueryFilterDrawer;
//# sourceMappingURL=QueryFilterDrawer.js.map